import { AppError } from '@app/errors/AppError'

/**
 * A chunk that will not load is usually a deploy: the document is old and names files the new
 * build no longer has. Webpack said `Loading chunk N failed`; past it the wording is the
 * browser's, and every engine has its own.
 *
 * Kept apart from `chunkLoadErrorReload`, which reaches for `window` and `@sentry/react` at module
 * scope — the server's event processor needs the predicate and none of that.
 */
export const isChunkLoadError = (err: unknown): boolean => {
  if (err instanceof Error) return err.name === 'ChunkLoadError' || CHUNK_ERROR_RE.test(err.message)
  if (typeof err === 'string') return CHUNK_ERROR_RE.test(err)
  return false
}

/**
 * Sentry drops chunk errors, since a reload fixes them. One still failing after its reload is
 * real, so it gets a name of its own to get past that filter.
 */
export const chunkErrorAfterReload = (err: unknown): unknown => (isChunkLoadError(err) ? new AppError('Chunk still fails after a reload', { cause: err }) : err)

/** A chunk's stylesheet, which vite reports on its own event before it throws. */
export const isStylesheetPreloadError = (err: unknown): boolean => err instanceof Error && CSS_PRELOAD_RE.test(err.message)

const CHUNK_ERROR_RE =
  /Loading (?:CSS )?chunk [^\s]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i
const CSS_PRELOAD_RE = /^Unable to preload CSS for /
